import { AUSnackBarTypes } from '@app/shared/models/snackbars/au-snackbar-types.enum';
import { IAUSnackBarData } from '@app/shared/models/snackbars/au-snackbar-data.model';
import { MatSnackBarConfig } from '@angular/material/snack-bar';
import { newGuid } from '@app/shared/services/guid.service';

export class AUSnackBarConfig {
  public error: any;
  public type: AUSnackBarTypes;

  private _config: MatSnackBarConfig;
  get config(): MatSnackBarConfig {
    return this._config;
  }

  get data(): IAUSnackBarData {
    return this._config.data as AUSnackBarData;
  }

  constructor(
    type: AUSnackBarTypes,
    title?: string,
    details?: string | string[],
    moreDetails?: string | string[]
  ) {
    this._config = new MatSnackBarConfig();
    this._config.duration = undefined;
    this._config.panelClass = 'snack-bar-panel';
    this._config.data = new AUSnackBarData();
    this.type = type;

    if (type === AUSnackBarTypes.Success) {
      this.data.duration = 5_000;
    }

    this.data.type = this.convertTypeToString(this.type);
    this.data.title = title;
    this.data.detailItems = details;
    this.data.moreDetailItems = moreDetails;

    if (Array.isArray(this.data.detailItems) && this.data.detailItems.length === 1) {
      this.data.detailItems = this.data.detailItems[0];
    }
  }

  setPanelClass(panelClass: string): AUSnackBarConfig {
    this._config.panelClass = panelClass;
    return this;
  }

  setDuration(duration: number): AUSnackBarConfig {
    this.data.duration = duration;
    return this;
  }

  setDetailData(details: string | string[]): AUSnackBarConfig {
    this.data.detailItems = details;
    return this;
  }

  setMoreDetailData(moreDetails: string | string[]): AUSnackBarConfig {
    this.data.moreDetailItems = moreDetails;
    return this;
  }

  setTitle(title: string): AUSnackBarConfig {
    this.data.title = title;
    return this;
  }

  private convertTypeToString(type: AUSnackBarTypes): string {
    return AUSnackBarTypes[type]?.toLowerCase();
  }
}

class AUSnackBarData implements IAUSnackBarData {
  closeSymbol = 'fa-times-circle';
  expandSymbol = 'fa-angle-down';
  closeExpandSymbol = 'fa-angle-up';
  detailItems: string | string[];
  moreDetailItems: string | string[];
  isCloseSymbolIcon = true;
  isMoreSymbolIcon = true;
  isListOrdered = false;
  title: string;
  id: string;
  isDetailInfoArray = false;
  isMoreDetailInfoArray = false;
  duration: number;
  type: string;
  defaultMoreDetailsExpanded = false;

  constructor() {
    this.id = newGuid();
    this.duration = undefined;
  }

  public initDetailItemsProps(): void {
    this.isDetailInfoArray = Array.isArray(this.detailItems);

    this.isMoreDetailInfoArray = Array.isArray(this.moreDetailItems);
  }
}
